import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import VideoGalleryModal from "../components/VideoGalleryModal";

interface GalleryVideo {
  id: string;
  title: string;
  thumbnail: string;
  videoUrl: string;
  prompt: string;
  character: string;
  dimensions: { width: number; height: number };
}

// Example videos for no-filter showcase with video previews
const noFilterVideos: GalleryVideo[] = [
  {
    id: "preview-1",
    title: "Mila's Secret",
    thumbnail: "/baddies/baddie14.jpg",
    videoUrl:
      "https://funnyclips-content.s3.us-east-1.amazonaws.com/Preview+%231.mp4",
    prompt: "",
    character: "No Filter",
    dimensions: { width: 765, height: 968 },
  },
  {
    id: "preview-2",
    title: "Aria's Dressover",
    thumbnail: "/baddies/baddie1.jpg",
    videoUrl:
      "https://funnyclips-content.s3.us-east-1.amazonaws.com/Preview+%232.mp4",
    prompt: "",
    character: "No Filter",
    dimensions: { width: 765, height: 968 },
  },
  {
    id: "preview-3",
    title: "Evelyn's Happy Place",
    thumbnail: "/baddies/baddie10.jpg",
    videoUrl:
      "https://funnyclips-content.s3.us-east-1.amazonaws.com/Preview+%233.mp4",
    prompt: "",
    character: "No Filter",
    dimensions: { width: 765, height: 968 },
  },
  {
    id: "preview-4",
    title: "Emily Wilding Out",
    thumbnail: "/baddies/baddie12.jpg",
    videoUrl:
      "https://funnyclips-content.s3.us-east-1.amazonaws.com/Preview+%234.mp4",
    prompt: "",
    character: "No Filter",
    dimensions: { width: 765, height: 968 },
  },
  {
    id: "preview-5",
    title: "Isabella's Fun Trip",
    thumbnail: "/baddies/baddie5.jpg",
    videoUrl:
      "https://funnyclips-content.s3.us-east-1.amazonaws.com/Preview+%235.mp4",
    prompt: "",
    character: "No Filter",
    dimensions: { width: 765, height: 968 },
  },
  {
    id: "preview-6",
    title: "Abigail Going Freaky",
    thumbnail: "/baddies/baddie11.jpg",
    videoUrl:
      "https://funnyclips-content.s3.us-east-1.amazonaws.com/Preview+%236.mp4",
    prompt: "",
    character: "No Filter",
    dimensions: { width: 765, height: 968 },
  },
  {
    id: "preview-7",
    title: "Sophia's Seduction",
    thumbnail: "/baddies/baddie4.jpg",
    videoUrl:
      "https://funnyclips-content.s3.us-east-1.amazonaws.com/Preview+%237.mp4",
    prompt: "",
    character: "No Filter",
    dimensions: { width: 765, height: 968 },
  },
  {
    id: "preview-8",
    title: "Mia Showing Off",
    thumbnail: "/baddies/baddie6.jpg",
    videoUrl:
      "https://funnyclips-content.s3.us-east-1.amazonaws.com/Preview+%238.mp4",
    prompt: "",
    character: "No Filter",
    dimensions: { width: 765, height: 968 },
  },
  {
    id: "preview-9",
    title: "Elizabeth's Secret",
    thumbnail: "/baddies/baddie13.jpg",
    videoUrl:
      "https://funnyclips-content.s3.us-east-1.amazonaws.com/Preview+%239.mp4",
    prompt: "",
    character: "No Filter",
    dimensions: { width: 765, height: 968 },
  },
  {
    id: "preview-10",
    title: "Avery's Tease",
    thumbnail: "/baddies/baddie16.jpg",
    videoUrl:
      "https://funnyclips-content.s3.us-east-1.amazonaws.com/Preview+%2310.mp4",
    prompt: "",
    character: "No Filter",
    dimensions: { width: 765, height: 968 },
  },
  {
    id: "preview-11",
    title: "Luna's Fantasy",
    thumbnail: "/baddies/baddie2.jpg",
    videoUrl:
      "https://funnyclips-content.s3.us-east-1.amazonaws.com/Preview+%2311.mp4",
    prompt: "",
    character: "No Filter",
    dimensions: { width: 765, height: 968 },
  },
  {
    id: "preview-12",
    title: "Nova's Adventure",
    thumbnail: "/baddies/baddie3.jpg",
    videoUrl:
      "https://funnyclips-content.s3.us-east-1.amazonaws.com/Preview+%2312.mp4",
    prompt: "",
    character: "No Filter",
    dimensions: { width: 765, height: 968 },
  },
  {
    id: "preview-13",
    title: "Charlotte's Night",
    thumbnail: "/baddies/baddie7.jpg",
    videoUrl:
      "https://funnyclips-content.s3.us-east-1.amazonaws.com/Preview+%2313.mp4",
    prompt: "",
    character: "No Filter",
    dimensions: { width: 765, height: 968 },
  },
  {
    id: "preview-14",
    title: "Amelia's Passion",
    thumbnail: "/baddies/baddie8.jpg",
    videoUrl:
      "https://funnyclips-content.s3.us-east-1.amazonaws.com/Preview+%2314.mp4",
    prompt: "",
    character: "No Filter",
    dimensions: { width: 765, height: 968 },
  },
  {
    id: "preview-15",
    title: "Harper's Temptation",
    thumbnail: "/baddies/baddie9.jpg",
    videoUrl:
      "https://funnyclips-content.s3.us-east-1.amazonaws.com/Preview+%2315.mp4",
    prompt: "",
    character: "No Filter",
    dimensions: { width: 765, height: 968 },
  },
];

const NoFilterExamples: React.FC = () => {
  const navigate = useNavigate();
  const [selectedGalleryVideo, setSelectedGalleryVideo] =
    useState<GalleryVideo | null>(null);
  const [isGalleryModalOpen, setIsGalleryModalOpen] = useState(false);
  const [shuffledVideos, setShuffledVideos] = useState<GalleryVideo[]>([]);
  const [loadedImages, setLoadedImages] = useState<Set<string>>(new Set());
  const [visibleImages, setVisibleImages] = useState<Set<string>>(new Set());

  // Shuffle array function
  const shuffleArray = <T,>(array: T[]): T[] => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  // Shuffle videos on mount
  useEffect(() => {
    setShuffledVideos(shuffleArray(noFilterVideos));
  }, []);

  // Track page view on mount (disabled for showcase)
  useEffect(() => {
    // Analytics removed for showcase site
  }, []);

  const handleGalleryVideoClick = (video: GalleryVideo) => {
    setSelectedGalleryVideo(video);
    setIsGalleryModalOpen(true);
  };

  const handleGalleryModalClose = () => {
    setIsGalleryModalOpen(false);
    setSelectedGalleryVideo(null);
  };

  const handleImageLoad = (imageUrl: string) => {
    setLoadedImages((prev) => new Set(prev).add(imageUrl));
  };

  // Intersection Observer for lazy loading
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const imgSrc = entry.target.getAttribute("data-src");
            if (imgSrc) {
              setVisibleImages((prev) => new Set(prev).add(imgSrc));
              observer.unobserve(entry.target);
            }
          }
        });
      },
      {
        rootMargin: "200px",
        threshold: 0.01,
      }
    );

    const lazyElements = document.querySelectorAll("[data-lazy-load]");
    lazyElements.forEach((el) => observer.observe(el));

    return () => {
      lazyElements.forEach((el) => observer.unobserve(el));
    };
  }, [shuffledVideos.length]);

  return (
    <div className="min-h-screen bg-black dark:bg-black p-6 pb-32 md:pb-6 transition-colors duration-300">
      <div className="max-w-7xl mx-auto space-y-8">
        {/* Back Button */}
        <div className="flex justify-start">
          <button
            onClick={() => navigate("/no-filter")}
            className="flex items-center gap-2 text-white hover:text-gray-300 transition-colors duration-200"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
            <span className="text-lg font-medium">Back to No Filter</span>
          </button>
        </div>

        {/* Example Videos Gallery */}
        <div className="animate-fade-in">
          <div className="text-center mb-6">
            <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
              No Filter Examples
            </h2>
            <p className="text-gray-600 dark:text-gray-300">
              See what's possible with unrestricted AI video generation
            </p>
          </div>

          {/* Video Grid - Masonry Style */}
          <div className="columns-2 md:columns-3 lg:columns-4 xl:columns-5 gap-3 md:gap-4 space-y-3 md:space-y-4">
            {shuffledVideos.map((video) => {
              const duration = "0:08";
              const thumbnailKey = video.videoUrl;
              const shouldLoad = visibleImages.has(thumbnailKey);
              const isThumbnailLoaded = loadedImages.has(thumbnailKey);

              return (
                <div
                  key={video.id}
                  className="group relative cursor-pointer rounded-xl overflow-hidden bg-gray-900 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 break-inside-avoid mb-3 md:mb-4 w-full"
                  onClick={() => handleGalleryVideoClick(video)}
                  style={{
                    aspectRatio: `${video.dimensions.width} / ${video.dimensions.height}`,
                  }}
                  data-lazy-load
                  data-src={thumbnailKey}
                >
                  {/* Video Preview */}
                  <div className="relative overflow-hidden h-full w-full">
                    {shouldLoad && !isThumbnailLoaded && (
                      <div className="absolute inset-0 flex items-center justify-center z-10 pointer-events-none">
                        <div className="w-12 h-12 border-2 border-white/20 border-t-white rounded-full animate-spin"></div>
                      </div>
                    )}
                    {shouldLoad ? (
                      <video
                        src={video.videoUrl}
                        className={`w-full h-full object-cover group-hover:scale-105 transition-transform duration-300 ${
                          isThumbnailLoaded ? "opacity-100" : "opacity-0"
                        }`}
                        muted
                        playsInline
                        preload="metadata"
                        poster=""
                        onLoadedData={() => handleImageLoad(thumbnailKey)}
                      />
                    ) : (
                      <div className="w-full h-full bg-gray-800"></div>
                    )}

                    {/* Dark Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />

                    {/* Video Name Badge */}
                    <div className="absolute top-3 left-3">
                      <span className="text-xs bg-purple-500 text-white px-2 py-1 rounded font-medium">
                        {video.title}
                      </span>
                    </div>

                    {/* Duration Badge */}
                    <div className="absolute top-3 right-3">
                      <span className="text-xs bg-black/80 text-white px-2 py-1 rounded font-medium">
                        {duration}
                      </span>
                    </div>

                    {/* Play Button Overlay */}
                    <div className="absolute inset-0 bg-black/20 flex items-center justify-center opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity duration-200">
                      <div className="w-12 h-12 bg-white/95 rounded-full flex items-center justify-center shadow-lg">
                        <svg
                          className="w-6 h-6 text-gray-800 ml-0.5"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path d="M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" />
                        </svg>
                      </div>
                    </div>

                    {/* Title Overlay */}
                    <div className="absolute bottom-0 left-0 right-0 p-3">
                      <h3 className="text-white font-semibold text-sm md:text-base leading-tight drop-shadow-lg">
                        {video.title}
                      </h3>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Disclaimer */}
        <div className="bg-white/5 dark:bg-white/5 border border-white/10 dark:border-white/10 rounded-xl p-6 text-center transition-colors duration-300">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
            Important Disclaimer
          </h3>
          <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed max-w-3xl mx-auto">
            The "No Filter" mode is designed for creative and entertainment
            purposes. Users are responsible for ensuring their content complies
            with platform guidelines and applicable laws. PixelMaker does not
            endorse or take responsibility for user-generated content.
          </p>
        </div>
      </div>

      {/* Video Gallery Modal */}
      <VideoGalleryModal
        isOpen={isGalleryModalOpen}
        onClose={handleGalleryModalClose}
        video={selectedGalleryVideo}
      />
    </div>
  );
};

export default NoFilterExamples;

